import React, { useEffect, useState } from 'react';

const Gallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch('/Data/Gallery.json')
      .then((res) => res.json())
      .then((data) => setImages(data))
      .catch((err) => console.error('Error loading JSON:', err));
  }, []);

  return (
   <div>
     {/* Hero Section =================*/}
      <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
          <img
            src="/image/bg3.jpg" alt="Hotel" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          
          {/* Black semi-transparent overlay */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // 0.4 মানে হালকা কালো
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '3rem',
            fontWeight: 'bold'
          }}>
             Gallery Grid
          </div>
        </div>
      {/* Gallery Section =================*/}
    <section className="py-5 " style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <h1><i>Gallery </i></h1>
        <div className="d-flex  flex-wrap justify-content-between pt-5 gap-3">
          {images.map((image) => (
            <div key={image.id} style={{ flex: '1 1 30%' }}>
              <img
                src={image.image}
                alt={image.title}
                className="img-fluid rounded w-100"
                style={{ height: '400px', objectFit: 'cover' }}
              />
              <h5 className="mt-2 text-center">{image.title}</h5>
            </div>
          ))}
        </div>
      </div>
    </section>
   </div>
  );
};

export default Gallery;
